/**
 * Copyright (c) 2022 Yoshinobu Obata
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

/**
 * テキストの言語を検出
 * @param {string} text - 検出対象のテキスト
 * @returns {string} 検出された言語キー (english, japanese, chinese, korean, etc.)
 */
function detectLanguage(text) {
    if (!text || text.trim() === '') {
        return 'english';
    }
    
    // 日本語: ひらがな、カタカナを含む
    const hiraganaKatakana = /[\u3040-\u309F\u30A0-\u30FF]/;
    if (hiraganaKatakana.test(text)) {
        return 'japanese';
    }
    
    // 韓国語: ハングルを含む
    const hangul = /[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F]/;
    if (hangul.test(text)) {
        return 'korean';
    }
    
    // 中国語: 漢字のみ（ひらがな・カタカナがない場合）
    const cjkUnified = /[\u4E00-\u9FFF]/;
    if (cjkUnified.test(text)) {
        return 'chinese';
    }
    
    // ラテン文字系の言語は区別が難しいため、英語として扱う
    return 'english';
}
/**
 * モデルのロード完了を待つ
 */
async function waitForModelReady(getStatusFunc) {
    return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
            const status = getStatusFunc();
            if (status === 'ready' || status === 'error') {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100);
    });
}

module.exports = {
    detectLanguage,
    waitForModelReady
};
